// extracted by mini-css-extract-plugin
export default {"title":"g--z","warning":"h--z","sizeOptionsLegendText":"i--z"};